import React from 'react'
import PropTypes from 'prop-types'
import { currencyFormat } from 'utils/format'

import DescItemInfo from 'ui-components/DescItemInfo/DescItemInfo'
import { Item } from './styles'

const ITEM_TYPES = {
  order: 'Pedido',
  customer_debt: 'Débito',
}

export default function PaymentItems({ paymentItems }) {
  const renderPaymentItem = (paymentItem) => (
    <Item key={`${paymentItem.id}-${paymentItem.type}`}>
      <DescItemInfo label="Tipo">
        {ITEM_TYPES[paymentItem.type]}
      </DescItemInfo>

      <DescItemInfo label="Número">
        {paymentItem.code}
      </DescItemInfo>

      <DescItemInfo label="R$ Valor">
        {currencyFormat(paymentItem.value)}
      </DescItemInfo>
    </Item>
  )

  return (
    <div>
      <h4>Itens para pagamento</h4>
      {paymentItems.map(renderPaymentItem)}
    </div>
  )
}

PaymentItems.propTypes = {
  paymentItems: PropTypes.arrayOf(PropTypes.object).isRequired,
}
